// extracted by mini-css-extract-plugin
export default {"root":"ClientsView_root__DgWz3","wrapper":"ClientsView_wrapper__7wpEg"};